import React, { FunctionComponent } from 'react';
import { H4 } from '../../../../design-system/Headings/Headings';

const WebhooksDocs: FunctionComponent = () => {
    return (
        <>
            <H4 className="mt-6 mb-4 font-medium">Webhooks</H4>
            <p className="pb-2 leading-relaxed">
                This section is automatically generated by APIMatic when you publish a portal for
                any supported programming language. It provides comprehensive documentation for all
                <b> Webhooks</b> defined in your API, including:
            </p>
            <ul className="pb-2 leading-relaxed bulletPoint">
                <li>
                    <b>Overview pages</b> for webhook groups, explaining how to verify events and
                    parse them using language-specific handlers.
                </li>
                <li>
                    <b>Individual event pages</b> detailing the required Headers, Payload, and
                    Response information.
                </li>
            </ul>
        </>
    );
};

export default WebhooksDocs;
